import { createSlice } from "@reduxjs/toolkit";

 const thermalData = createSlice({
    name : 'thermal',
    initialState:{
        getThermalData: null,
        onPress : false
    },
    reducers:{
    setThermalData(state, action){
        console.log(action.payload)
        state.getThermalData = action.payload
        console.log(state.getThermalData)
    },
    onPressButton(state){
        console.log(state.onPress)
        state.onPress= !state.onPress
    },
    resetData(state){
        state.getThermalData = null
        state.onPress = false 
    }
    }
})


export const { setThermalData, resetData, onPressButton } = thermalData.actions
export default thermalData.reducer
